import '../scss/style.scss';
import './woocommerce.js';
import './order-addresses.js';
import './composite-step-recap.js';

import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';
import Carousel from "bootstrap/js/dist/carousel";

const initTooltips = () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((node) => {
        new Tooltip(node);
    });
};

const initNavAutoclose = () => {
    document.querySelectorAll('.navbar [data-smoothscroll], .navbar a[href^="#"]').forEach((link) => {
        link.addEventListener('click', () => {
            const nav = link.closest('.navbar-collapse');
            if (!nav) {
                return;
            }

            const instance = Collapse.getInstance(nav);
            if (instance) {
                instance.hide();
            }
        });
    });
};

const initDropdownHover = () => {
    let dropdownActiveTimer = null;
    const hoverIntentDelay = 300;
    const hoverCloseDelay = 150;

    document.querySelectorAll('.navbar .dropdown, .navbar .dropend').forEach((item) => {
        const toggle = item.querySelector('[data-bs-toggle="dropdown"]');
        if (!toggle) {
            return;
        }
        let hoverIntentTimer = null;
        let hoverCloseTimer = null;

        item.addEventListener('mouseenter', () => {
            clearTimeout(hoverIntentTimer);
            clearTimeout(hoverCloseTimer);
            const nav = item.closest('.navbar-collapse');
            if (nav && nav.classList.contains('show')) {
                return;
            }
            hoverIntentTimer = setTimeout(() => {
                if (item.matches(':hover') && !(nav && nav.classList.contains('show'))) {
                    Dropdown.getOrCreateInstance(toggle).show();
                }
            }, hoverIntentDelay);
        });

        item.addEventListener('mouseleave', () => {
            clearTimeout(hoverIntentTimer);
            clearTimeout(hoverCloseTimer);
            const nav = item.closest('.navbar-collapse');
            if (nav && nav.classList.contains('show')) {
                return;
            }
            hoverCloseTimer = setTimeout(() => {
                if (!item.matches(':hover') && !(nav && nav.classList.contains('show'))) {
                    Dropdown.getOrCreateInstance(toggle).hide();
                    toggle.blur();
                }
            }, hoverCloseDelay);
        });

        toggle.addEventListener('show.bs.dropdown', () => {
            clearTimeout(hoverIntentTimer);
            clearTimeout(hoverCloseTimer);
            clearTimeout(dropdownActiveTimer);
            document.body.classList.add('dropdown-active');
        });

        toggle.addEventListener('hide.bs.dropdown', () => {
            clearTimeout(hoverIntentTimer);
            clearTimeout(hoverCloseTimer);
            dropdownActiveTimer = setTimeout(() => {
                if (!document.querySelector('.navbar .dropdown-menu.show')) {
                    document.body.classList.remove('dropdown-active');
                }
            }, 300);
        });
    });
};

const initCarousels = () => {
    var carousels = document.querySelectorAll('.carousel');

    carousels.forEach(function(carousel) {
        if (carousel.dataset.animateheight == "true") {
            var height = carousel.querySelector(".carousel-item.active").offsetHeight;

            if (height > 0) {
                var carouselInner = carousel.querySelectorAll(".carousel-inner")[0];
                carouselInner.style.height = height + "px";

                carousel.addEventListener('slide.bs.carousel', function (event) {
                    setTimeout(function () {
                        var newHeight = event.relatedTarget.offsetHeight - 1;

                        var carouselInner = carousel.querySelectorAll(".carousel-inner")[0];
                        carouselInner.style.height = newHeight + "px";
                    }, 5);
                })

                window.addEventListener("resize", debounce(function (event) {
                    carouselInner.style = "";

                    setTimeout(function () {
                        var newHeight = carousel.querySelector(".carousel-item.active").offsetHeight;

                        var carouselInner = carousel.querySelectorAll(".carousel-inner")[0];
                        carouselInner.style.height = newHeight + "px";
                    }, 5);
                }));
            }
        }

        function updateCarouselClasses(carousel, activeItem) {
            carousel.querySelectorAll('.carousel-item').forEach(function (item) {
                item.classList.remove('carousel-item-next', 'carousel-item-prev', 'carousel-item-after-next', 'carousel-item-before-prev', 'carousel-item-active');
            });

            activeItem.classList.add('carousel-item-active');

            // Add custom class to the next item
            if (activeItem.nextElementSibling) {
                activeItem.nextElementSibling.classList.add('carousel-item-next');

                // Add custom class to the item after the next item
                if (activeItem.nextElementSibling.nextElementSibling) {
                    activeItem.nextElementSibling.nextElementSibling.classList.add('carousel-item-after-next');
                } else {
                    carousel.querySelector('.carousel-item:first-child').classList.add('carousel-item-after-next');
                }
            } else {
                carousel.querySelector('.carousel-item:first-child').classList.add('carousel-item-next');
                carousel.querySelector('.carousel-item:nth-child(2)').classList.add('carousel-item-after-next');
            }

            // Add custom class to the previous item
            if (activeItem.previousElementSibling) {
                activeItem.previousElementSibling.classList.add('carousel-item-prev');

                // Add custom class to the item before the previous item
                if (activeItem.previousElementSibling.previousElementSibling) {
                    activeItem.previousElementSibling.previousElementSibling.classList.add('carousel-item-before-prev');
                } else {
                    carousel.querySelector('.carousel-item:last-child').classList.add('carousel-item-before-prev');
                }
            } else {
                carousel.querySelector('.carousel-item:last-child').classList.add('carousel-item-prev');
                carousel.querySelector('.carousel-item:nth-last-child(2)').classList.add('carousel-item-before-prev');
            }
        }

        if (carousel.parentElement.classList.contains("style_layered")) {
            // Run on carousel initialization
            updateCarouselClasses(carousel, carousel.querySelector('.carousel-item.active'));

            // Run on slide event
            carousel.addEventListener('slide.bs.carousel', function (event) {
                updateCarouselClasses(carousel, event.relatedTarget);
            });
        }
    });

    document.querySelectorAll('.carousel.carousel_scroll').forEach(function(scroller) {
        var cardRow = scroller.querySelector('.row');
        var scrollerNext = scroller.querySelector('.carousel-control-next');
        var scrollerPrev = scroller.querySelector('.carousel-control-prev');
        var scrollerLinks = scroller.querySelectorAll('a');

        var autoScroll = false;
        var scrollerInterval;

        if(window.innerWidth >= 1240) {
            if (scroller.dataset.scrollerRide) {
                if (scroller.dataset.scrollerRide == "carousel") {
                    autoScroll = true;
                    var interval = 3000;

                    if (scroller.dataset.scrollerInterval) {
                        interval = scroller.dataset.scrollerInterval;
                    }

                    function scrollerNext() {
                        if (cardRow.scrollLeft == (cardRow.scrollWidth - cardRow.offsetWidth)) {
                            cardRow.scroll({
                                left: 0,
                                behavior: "smooth",
                            });
                        } else {
                            cardRow.scroll({
                                left: (cardRow.scrollLeft + cardRow.offsetWidth),
                                behavior: "smooth",
                            });
                        }
                    }

                    scrollerInterval = setInterval(scrollerNext, interval);
                }
            }
        }

        if (scrollerNext) {
            scrollerNext.onclick = (event) => {
                cardRow.scroll({
                    left: (cardRow.scrollLeft + cardRow.offsetWidth),
                    behavior: "smooth",
                });

                if (autoScroll) {
                    clearInterval(scrollerInterval);
                }
            };
        }

        if (scrollerPrev) {
            scrollerPrev.onclick = (event) => {
                cardRow.scroll({
                    left: (cardRow.scrollLeft - cardRow.offsetWidth),
                    behavior: "smooth",
                });

                if (autoScroll) {
                    clearInterval(scrollerInterval);
                }
            };
        }

        if (scrollerLinks) {
            scrollerLinks.forEach(function(link) {
                link.onclick = (event) => {
                    if (autoScroll) {
                        clearInterval(scrollerInterval);
                    }
                };
            });
        }

        if (cardRow.scrollLeft == 0) {
            if (scrollerPrev) {
                scroller.querySelector(".carousel-control-prev").classList.add("disabled");
            }
        } else if (cardRow.scrollLeft >= (cardRow.scrollWidth - cardRow.offsetWidth) - 1) {
            if (scrollerNext) {
                scroller.querySelector(".carousel-control-next").classList.add("disabled");
            }
        }

        cardRow.addEventListener("scroll", (event) => {
            if (scrollerNext) {
                if (cardRow.scrollLeft == 0) {
                    scroller.querySelector(".carousel-control-prev").classList.add("disabled");
                } else {
                    scroller.querySelector(".carousel-control-prev").classList.remove("disabled");
                }

                if (cardRow.scrollLeft >= (cardRow.scrollWidth - cardRow.offsetWidth) - 1) {
                    scroller.querySelector(".carousel-control-next").classList.add("disabled");
                } else {
                    scroller.querySelector(".carousel-control-next").classList.remove("disabled");
                }
            }
        });
    });
};

const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
};

const initShareButtons = () => {
    document.querySelectorAll('[data-copy-link]').forEach((button) => {
        button.addEventListener('click', async () => {
            const url = button.getAttribute('data-copy-link') || window.location.href;
            const label = button.querySelector('span');

            try {
                await copyTextToClipboard(url);
                if (label) {
                    const originalText = label.textContent;
                    label.textContent = 'Copied!';
                    setTimeout(() => {
                        label.textContent = originalText;
                    }, 1200);
                }
            } catch (error) {
                if (label) {
                    const originalText = label.textContent;
                    label.textContent = 'Unable to copy';
                    setTimeout(() => {
                        label.textContent = originalText;
                    }, 1200);
                }
            }
        });
    });

    document.querySelectorAll('[data-share-instagram]').forEach((link) => {
        link.addEventListener('click', async (event) => {
            const url = link.getAttribute('data-share-url') || window.location.href;
            const title = link.getAttribute('data-share-title') || document.title;

            if (!navigator.share) {
                return;
            }

            event.preventDefault();

            try {
                await navigator.share({
                    title,
                    text: title,
                    url,
                });
            } catch (error) {
                // Ignore cancellations and fall back to the href behavior.
                window.open(link.href, '_blank', 'noopener,noreferrer');
            }
        });
    });
};

const initNumericRangeFilters = () => {
    document.querySelectorAll('[data-numeric-range-filter]').forEach((filterNode) => {
        const minSlider = filterNode.querySelector('[data-range-min-slider]');
        const maxSlider = filterNode.querySelector('[data-range-max-slider]');
        const minInput = filterNode.querySelector('[data-range-min-input]');
        const maxInput = filterNode.querySelector('[data-range-max-input]');
        const minDisplay = filterNode.querySelector('[data-range-min-display]');
        const maxDisplay = filterNode.querySelector('[data-range-max-display]');
        const track = filterNode.querySelector('[data-range-track]');
        const rangeValues = JSON.parse(filterNode.getAttribute('data-range-values') || '[]');
        const defaultMin = filterNode.getAttribute('data-range-min-default') || '';
        const defaultMax = filterNode.getAttribute('data-range-max-default') || '';

        if (!minSlider || !maxSlider || !minInput || !maxInput || !rangeValues.length) {
            return;
        }

        const maxIndex = Math.max(rangeValues.length - 1, 0);

        const updateSlider = (source) => {
            let minIndex = Number(minSlider.value);
            let maxIndexValue = Number(maxSlider.value);

            if (minIndex > maxIndexValue) {
                if (source === 'min') {
                    maxIndexValue = minIndex;
                    maxSlider.value = String(maxIndexValue);
                } else {
                    minIndex = maxIndexValue;
                    minSlider.value = String(minIndex);
                }
            }

            const minValue = rangeValues[minIndex] ?? defaultMin;
            const maxValue = rangeValues[maxIndexValue] ?? defaultMax;

            if (minDisplay) {
                minDisplay.textContent = String(minValue);
            }

            if (maxDisplay) {
                maxDisplay.textContent = String(maxValue);
            }

            minInput.value = minIndex <= 0 ? '' : String(minValue);
            maxInput.value = maxIndexValue >= maxIndex ? '' : String(maxValue);

            if (track) {
                const minPercent = maxIndex === 0 ? 0 : (minIndex / maxIndex) * 100;
                const maxPercent = maxIndex === 0 ? 100 : (maxIndexValue / maxIndex) * 100;

                track.style.left = `${minPercent}%`;
                track.style.width = `${Math.max(maxPercent - minPercent, 0)}%`;
            }
        };

        minSlider.addEventListener('input', () => {
            updateSlider('min');
        });

        maxSlider.addEventListener('input', () => {
            updateSlider('max');
        });

        updateSlider();
    });
};

const initCustomNumericRangeFilterChips = () => {
    const chipLists = document.querySelectorAll('.wc-block-product-filter-removable-chips__items');

    if (!chipLists.length) {
        return;
    }

    chipLists.forEach((chipList) => {
        chipList.querySelectorAll('[data-custom-range-chip="1"]').forEach((node) => {
            node.remove();
        });
    });

    document.querySelectorAll('[data-numeric-range-filter]').forEach((filterNode) => {
        const isActive = filterNode.getAttribute('data-range-chip-active') === '1';

        if (!isActive) {
            return;
        }

        const chipKey = filterNode.getAttribute('data-range-chip-key') || '';
        const chipLabel = filterNode.getAttribute('data-range-chip-label') || '';
        const removeUrl = filterNode.getAttribute('data-range-chip-remove-url') || '';

        if (!chipLabel || !removeUrl) {
            return;
        }

        chipLists.forEach((chipList) => {
            if (chipKey) {
                const existingChip = chipList.querySelector(`[data-custom-range-chip-key="${chipKey}"]`);

                if (existingChip) {
                    existingChip.remove();
                }
            }

            const chip = document.createElement('li');
            chip.className = 'wc-block-product-filter-removable-chips__item';
            chip.setAttribute('data-custom-range-chip', '1');

            if (chipKey) {
                chip.setAttribute('data-custom-range-chip-key', chipKey);
            }

            const label = document.createElement('span');
            label.className = 'wc-block-product-filter-removable-chips__label';
            label.textContent = chipLabel;

            const removeLink = document.createElement('a');
            removeLink.className = 'wc-block-product-filter-removable-chips__remove';
            removeLink.href = removeUrl;
            removeLink.setAttribute('aria-label', `Remove filter: ${chipLabel}`);

            removeLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="25" height="25" class="wc-block-product-filter-removable-chips__remove-icon" aria-hidden="true" focusable="false"><path d="M12 13.06l3.712 3.713 1.061-1.06L13.061 12l3.712-3.712-1.06-1.06L12 10.938 8.288 7.227l-1.061 1.06L10.939 12l-3.712 3.712 1.06 1.061L12 13.061z"></path></svg>';

            const srText = document.createElement('span');
            srText.className = 'screen-reader-text';
            srText.textContent = `Remove filter: ${chipLabel}`;

            removeLink.appendChild(srText);
            chip.appendChild(label);
            chip.appendChild(removeLink);
            chipList.appendChild(chip);
        });
    });
};

const initPaperCalculators = async () => {
    const mountNode = document.querySelector('#paper-calculators-app');

    if (!mountNode) {
        return;
    }

    const { mountPaperCalculators } = await import('./calculators/bootstrap.js');
    mountPaperCalculators(mountNode);
};

const initAlertBar = () => {
    let alertBarElement = document.querySelector('.alert_bar');

    if(alertBarElement) {
        let alertBarTitle = alertBarElement.dataset.alertbar;
        let alertBarHideButton = alertBarElement.querySelector('.btn-close');

        alertBarHideButton.onclick = (event) => {
            document.querySelector('.alert_bar').classList.add("d-none");
            document.documentElement.style.setProperty('--alert-bar-height', "0px");

            // Store the expiration date of the current alert bar in localStorage.
            var expires = new Date();

            // Default expiration is 7 days
            var expirationLength = 168;

            // To do: If the alert bar has an end date check that and use that
            var newHoursWithDecimal = expires.getHours() + expirationLength;
            var newHours = Math.floor(newHoursWithDecimal);
            var newMinutes = expires.getMinutes() + ((newHoursWithDecimal - Math.floor(newHoursWithDecimal)) * 60);

            expires = expires.setHours(newHours, newMinutes);

            localStorage.setItem( "alertBar-" + alertBarTitle, expires );
        };

        var existingAlertBarExpiration = localStorage.getItem( "alertBar-" + alertBarTitle );

        if(existingAlertBarExpiration > new Date()) {
            alertBarElement.classList.add("d-none");
        } else {
            alertBarElement.classList.remove("d-none");
        }
    }
};

function debounce(func){
	var timer;
	return function(event){
		if(timer) clearTimeout(timer);
		timer = setTimeout(func,100,event);
	};
}

const boot = async () => {
    initTooltips();
    initNavAutoclose();
    initDropdownHover();
    initShareButtons();
    initNumericRangeFilters();
    initCustomNumericRangeFilterChips();
    initCarousels();
    initAlertBar();
    await initPaperCalculators();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}

export { Collapse, Dropdown, Offcanvas, Modal, Tab };
window.aconvertBootstrap = { Collapse, Dropdown, Offcanvas, Modal, Tab };
